export const categoryList = [
    { value: 'cinema', text: 'kino' },
    { value: 'theater', text: 'teatar' },
    { value: 'concert', text: 'kontsert' },
    { value: 'opera', text: 'opera' },
    { value: 'ballet', text: 'balet' },
    { value: 'musical', text: 'myuzikal' },
    { value: 'sports', text: 'sport' },
    { value: 'festival', text: 'festival' },
    { value: 'fair', text: 'panair' },
    { value: 'artexhibition', text: 'izlozhba' },
    { value: 'exhibition', text: 'izlozhenie' },
    { value: 'conference', text: 'konferentsiya' },
    { value: 'forum', text: 'forum' },
    { value: 'event', text: 'sabitiye' },
]


export const getCategoryColor = (category) => {
    switch (category) {
        case 'cinema': return 'from-blue-500 to-cyan-500';
        case 'theater': return 'from-purple-500 to-pink-500';
        case 'concert': return 'from-orange-500 to-red-500';
        case 'opera': return 'from-red-500 to-rose-500';
        case 'ballet': return 'from-pink-500 to-rose-500';
        case 'musical': return 'from-yellow-500 to-orange-500';
        case 'sports': return 'from-green-500 to-emerald-500';
        case 'festival': return 'from-indigo-500 to-purple-500';
        case 'fair': return 'from-amber-500 to-yellow-500';
        case 'artexhibition': return 'from-teal-500 to-emerald-500';
        case 'exhibition': return 'from-slate-500 to-gray-500';
        case 'conference': return 'from-sky-500 to-blue-500';
        case 'forum': return 'from-cyan-500 to-blue-500';
        case 'event': return 'from-violet-500 to-fuchsia-500';
        default: return 'from-primary-500 to-accent-500';
    }
}

export const getCategoryLabel = (category) => {
    switch (category) {
        case 'cinema': return window.t('kino');
        case 'theater': return window.t('teatar');
        case 'concert': return window.t('kontsert');
        case 'opera': return window.t('opera');
        case 'ballet': return window.t('balet');
        case 'musical': return window.t('myuzikal');
        case 'sports': return window.t('sport');
        case 'festival': return window.t('festival');
        case 'fair': return window.t('panair');
        case 'artexhibition': return window.t('izlozhba');
        case 'exhibition': return window.t('izlozhenie');
        case 'conference': return window.t('konferentsiya');
        case 'forum': return window.t('forum');
        case 'event': return window.t('sabitiye');
        default: return window.t(category);
    }
}

export const getHeroImageByCategory = (category) => {
    switch (category) {
        case 'cinema': return 'cinema.svg'
        case 'theater': return 'theater.svg'
        case 'concert': return 'concert.svg'
        case 'sport': return 'sport.svg'
        case 'art': return 'art.svg'
        default: return 'other.svg'
    }
}